import cn from "classnames";

import { useTranslation } from "react-i18next";
import { ColumnChartStacked } from "src/main";
import { useScenarioManagerWidget } from "./hooks/useScenarioManagerWidget";
import { observer } from "mobx-react-lite";
import { ReportWidgetProps } from "../ReportWidgetProps";

export const ScenarioManagerWidget = observer(
  ({
    benchmarkName = "Benchmark",
    currency,
    pageId,
    cellId,
    width,
    height,
    isHalfHeight,
  }: ReportWidgetProps) => {
    const { t } = useTranslation();
    const { impacts, percentageImpact, categoryMap, selectedCategory } =
      useScenarioManagerWidget(cellId, pageId);

    const valueFormatter = (num?: number) =>
      `${currency} ${
        typeof num === "undefined"
          ? ""
          : num.toLocaleString(undefined, { maximumFractionDigits: 0 })
      }`;

    return (
      <div>
        <h6 className={cn("element-title")}>
          {t("Sensitivity to market moves")}
        </h6>
        <div style={{ height: 20 }} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <p>{t(`Beta vs ${benchmarkName}`)}</p>
            <p>
              <span>{t(`P&L Impact : `)}</span>
              <span
                style={{
                  color: impacts.pnlImpact >= 0 ? "var(--good)" : "var(--bad)",
                }}
              >
                {`${valueFormatter(impacts.pnlImpact)} `}
              </span>
              <span>
                (
                {percentageImpact.toLocaleString(undefined, {
                  maximumFractionDigits: 1,
                })}
                % {`${t("of portfolio")}`})
              </span>
            </p>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <p style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <svg width="20" height="20">
                <circle fill="blue" r="10" cx="10" cy="10"></circle>
              </svg>
              &nbsp;Price : {valueFormatter(impacts.priceImpact)}
            </p>
            <p style={{ display: "flex", alignItems: "center", gap: "5px" }}>
              <svg width="20" height="20">
                <circle fill="orange" r="10" cx="10" cy="10"></circle>
              </svg>
              &nbsp;Fx : {valueFormatter(impacts.fxImpact)}
            </p>
          </div>
        </div>

        <ColumnChartStacked
          width={width}
          height={height}
          data={(categoryMap.get(selectedCategory) ?? []).sort((a, b) =>
            a.name.localeCompare(b.name)
          )}
          hideLegend
          renderEmpty={<div />}
          isHalfHeight={isHalfHeight}
        />
      </div>
    );
  }
);
